var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-icon',{staticClass:"iconButton",attrs:{"icon":_vm.getIsPlaying ? 'volume-mute-fill' : 'volume-up-fill'},on:{"click":function($event){return _vm.toggleSound()}}})}
var staticRenderFns = []

export { render, staticRenderFns }